import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-minus",
  "use": "icon-minus-usage",
  "viewBox": "0 0 40 7",
  "content": "<symbol viewBox=\"0 0 40 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-minus\">\r\n<path id=\"icon-minus_Vector\" d=\"M-1.31134e-07 3.97851C-2.03571e-07 5.63567 2.12304 6.97852 4.7403 6.97852L35.2569 6.97852C37.877 6.97847 40 5.63567 40 3.97852C40 2.32136 37.877 0.978516 35.2569 0.978515L4.74038 0.978514C2.12304 0.978514 -5.86955e-08 2.32131 -1.31134e-07 3.97851Z\" fill=\"white\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol